import { Tasks as TasksComponent } from '@components/Tasks/Tasks'

export const Tasks = () => {
  return <TasksComponent />
}
